import styled from "styled-components"

export const Anchor = styled.a`
  text-decoration: none;
  color: ${props =>
    props.color ? props.theme.colors[props.color] : props.theme.colors.accent};
  font-weight: ${props => props.fontWeight || 700};
  &:hover {
    text-decoration: underline;
  }
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;
`
